import { ref } from 'vue'
import { defineStore } from 'pinia'

export type NotificationKind = 'info' | 'success' | 'error'

export interface Notification {
  id: number
  kind: NotificationKind
  /* i18n key preferred; falls back to raw text when key is not found */
  message: string
}

const AUTO_DISMISS_MS = 6000

let nextId = 1

export const useNotificationsStore = defineStore('notifications', () => {
  const items = ref<Notification[]>([])

  function notify(kind: NotificationKind, message: string): number {
    const id = nextId++
    items.value.push({ id, kind, message })
    if (typeof window !== 'undefined') {
      window.setTimeout(() => dismiss(id), AUTO_DISMISS_MS)
    }
    return id
  }

  function dismiss(id: number): void {
    items.value = items.value.filter((n) => n.id !== id)
  }

  return { items, notify, dismiss }
})
